import React from "react";
import UserScreenWindow from "./UserScreenWindow";

function LaundryUser() {
  return <UserScreenWindow label="Laundry">LaundryUser</UserScreenWindow>;
}

export default LaundryUser;
